import(/* webpackMode: "eager" */ "/vercel/path0/src/app/music/[id]/page.tsx");
